/* import __COLOCATED_TEMPLATE__ from './toggle-password-mask.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();